<template>
  <div>
    <vx-card :title="$t('schedule.schedule')" class="mb-base">
      <!-- 新增預約通知 按鈕 -->
      <template slot="actions">
        <vs-button class="cd-button-4w-icon" icon-pack="feather" icon="icon-plus" @click="showAddMessage">{{$t('schedule.addSchedule')}}</vs-button>
      </template>
      <vs-divider class="my-0" color="black"></vs-divider>
      <vs-row class="list">
        <vs-col v-if="scheduleData.length!=0">
          <vs-list>
            <vs-list-item :title="item.to_pid ? $t('schedule.Topatient')+item.pname :$t('schedule.ToStaff')+item.pname"  :subtitle="item.message" v-for="(item, index) in scheduleData" :key="index">
              <vs-row>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center">
                  <div class="text-right">
                    <!-- 建立時間 -->
                    <p class="cd-date text-base" v-if="windowWidth >= 768">{{$t('schedule.setTime')}}: {{ item.created_at }}</p>
                    <!-- 預計發送時間 -->
                    <p class="cd-date text-base" v-if="windowWidth >= 768">{{$t('schedule.sendTime')}}: {{ item.send_at }}</p>
                  </div>
                  <!-- 完成 -->
                  <p class="cd-chip ml-2 text-base" style="width: 60px; color: grey;" v-if="item.read_status==1">{{$t('schedule.finish')}}</p>
                  <!-- 已發送 -->
                  <p class="cd-chip ml-2 text-base" style="width: 60px; color: dark;" v-else-if="item.read_status==0 && item.pm_text">{{$t('schedule.hasSend')}}</p>
                  <!-- 待發送 -->
                  <p class="cd-chip ml-2 text-base" style="width: 60px; color: dark;" v-else-if="item.message && !item.pm_text">{{$t('schedule.notSend')}}</p>
                  <!-- 失敗 -->
                  <p class="cd-chip ml-2 text-base" style="width: 60px;"  v-else>{{$t('schedule.fail')}}</p>
                  <!-- 編輯 -->
                  <vs-button size="large" type="flat" :color="checkTime(item.send_at) ?'grey' : 'dark'" :disabled="checkTime(item.send_at)" icon-pack="feather" icon="icon-edit" @click="showEditDialog(item)"></vs-button>
                  <!-- 刪除 -->
                  <vs-button size="large" type="flat" :color="checkTime(item.send_at) ?'grey' : 'dark'" :disabled="checkTime(item.send_at)" icon-pack="feather" icon="icon-trash-2" @click="delSchedule(item)"></vs-button>
                </vs-col>
              </vs-row>
            </vs-list-item>
          </vs-list>
        </vs-col>
        <vs-col class="mt-10" vs-type="flex" vs-justify="center" v-else>
          <span class="justify-content-between">{{$t('schedule.noData')}}!</span>
        </vs-col>
        <vs-col class="mt-10" vs-type="flex" vs-justify="center" >
          <vs-pagination :max="windowWidth <= 600 ? 7 : 9" :total="Math.ceil(total/20)" v-model="page" @change="getScheduleList(page)" v-if="total!=0"></vs-pagination>
        </vs-col>
      </vs-row>
    </vx-card>
    <!-- 編輯我的預約 視窗 -->
    <vs-popup
      :active.sync="editSchedulePopup"
      :title="$t('schedule.editSchedule')"
      >
      <!-- 存個id -->
      <input type="hidden" v-model="editid">
      <!-- 選時間日期 -->
      <el-date-picker
        class="cd-form-group"
        id="msgdate"
        v-model="editscheduleTime"
        type="datetime"
        :picker-options="pickerOptions"
        :placeholder="$t('schedule.selectDateTime')">
      </el-date-picker>
      <!-- 內容 -->
      <vs-textarea class="cd-form-group" :placeholder="$t('schedule.content')" height="200" v-model="editContent" />
      <!-- 更新 按鈕 -->
      <div class="text-center">
        <vs-button class="cd-button-2w" @click="updateSchedule">{{$t('schedule.update')}}</vs-button>
      </div> 
    </vs-popup>
    <!-- 新增預約通知 -->
    <vs-popup
      :active.sync="addMessage"
      :title="$t('AddScheduleBtn')"
      style="z-index:20000;"
      @close="close">
      <vs-row>
        <!-- 選民眾或醫事人員 -->
        <vs-col class="cd-form-group">
          <el-radio size="medium" v-model="identify_radio_type" label="2">單位民眾</el-radio>
          <el-radio size="medium" v-model="identify_radio_type" label="0">{{$t('schedule.patient')}}</el-radio>
          <el-radio size="medium" v-model="identify_radio_type" label="1">{{$t('schedule.medicalStaff')}}</el-radio>
        </vs-col>
        <!-- 選擇民眾 下拉式選單 -->
        <!-- <vs-col class="cd-form-group" v-if="identify_radio_type=='0'">
          <el-select
            class="select_member w-full"
            multiple
            filterable
            remote
            :remote-method="getVIPMember"
            v-model="selectedPid"
            size="'medium'"
            popper-class="cd-el-select"
            :placeholder="$t('schedule.selectPatient')">

            <el-option :key="index" :label="item.name+' ('+item.account+')'" :value="item.pid" v-for="(item, index) in allvipmembers"></el-option>
          </el-select>
        </vs-col> -->
        <div v-if="identify_radio_type=='0'" style="padding-bottom: 3px;"> 
          <el-tag style="margin-right: 3px;"  v-for="(item, index) in selectpid.pnames" :key="index" closable @close="addMemberDoc({pid: selectpid.pids[index], name: item})">
              {{ item }}
            </el-tag>
        </div>
          <vs-col v-if="identify_radio_type=='0'" class="cd-form-group dialog-doc-section">
            <el-input
              :placeholder="$t('schedule.selectPatient')"
              v-model="query"
              clearable
              class="filter select_member w-full"
              @input="getVIPMember"/>
            <div class="list">
              <div v-for="(item,index) in allvipmembers" :key="index" class="item" @click="addMemberDoc(item)">
                <i v-if="selectpid.pids.indexOf(item.pid) > -1" class="el-icon-minus"/>
                <i v-else class="el-icon-plus"/>
                <span style="margin-left: 1em;font-size: 0.9em;">{{'('}}{{ item.account }}{{')' }} </span>
                <span style="margin-left: 1em;font-size: 0.9em;">{{ item.name }}</span>
              </div>
            </div>
          </vs-col>
          <!-- {{ selectpid.pids }} -->
        <!-- 選擇醫事人員 下拉式選單 -->
        <vs-col class="cd-form-group" v-if="identify_radio_type=='1'">
          <el-select
            class="select_member w-full"
            multiple
            filterable
            v-model="selectedDid"
            size="'medium'"
            popper-class="cd-el-select"
            :placeholder="$t('schedule.selectDoctor')"
            >
            <el-option :key="index" :label="item.di_name?item.name+'('+item.di_name +')' :item.name " :value="item.did" v-for="(item, index) in contacts"></el-option>
          </el-select>
        </vs-col>
        <!-- 選擇單位民眾 下拉式選單 -->
        <vs-col class="cd-form-group" v-if="identify_radio_type=='2'">
          <el-select
            class="select_member w-full"
            multiple
            filterable
            v-model="selectedUnit"
            size="'medium'"
            popper-class="cd-el-select"
            :placeholder="'請選擇單位'"
            >
            <el-option :key="index" :label="item.name" :value="item.enterprise_id" v-for="(item, index) in unitList"></el-option>
          </el-select>
        </vs-col>
        <!-- 選日期 -->
        <vs-col class="cd-form-group">
          <el-date-picker
            class="w-full"
            v-model="selectedDateTime"
            type="datetime"
            popper-class="cd-el-select"
            :picker-options="pickerOptions"
            :placeholder="$t('schedule.selectDateTime')">
          </el-date-picker>
        </vs-col>
        <!-- 內容 -->
        <vs-col class="cd-form-group">
          <vs-textarea class="w-full" :placeholder="$t('schedule.content')" height="50" v-model="message" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end">
          <vs-button class="cd-button-2w mr-4" type="flat" @click="close">{{ $t('popup.cancel') }}</vs-button>
          <vs-button class="cd-button-2w" @click="sendMsgSchedule" :disabled="message==''||selectedDateTime==''||(selectpid.pids==''&&selectedDid==''&&selectedUnit=='')">{{$t('popup.add')}}</vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { fetchSchedule, updateSchedule, getCountByUnreadSchedule, delSchedule, saveSchedule, QueryDoctorListByPartner, getMemberFilter } from '@/api/user'

export default {
  data() {
    return {
      editid: 0,
      editContent: '',
      editscheduleTime:'',
      editSchedulePopup: false,
      scheduleData: [],
      scroll: 0,
      page: 1,
      nodataFlag: 0,
      identify_radio_type: "0",//醫生與民眾類型選擇
      selectedPid: [],
      selectedDid: [],
      selectedUnit: [],
      message: '',
      addMessage: false,
      selectedDateTime: '',
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()-86400000;
        },
      },
      query: '',
      selectpid: {
        pnames: [],
        pids: []
      },
      contacts: [],
      unitList: [],
    }
  },
  inject: [
    'reload'
  ],
  watch: {
  },
  computed: {
    msgaddtime() {
      return this.message
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    uiastaff() {
      return this.$store.getters.uiastaff
    },
    allvipmembers() {
      return this.$store.getters.allvipmembers
    },
    // contacts() {
    //   var sortdata = _.sortBy(this.$store.getters.contactsall, [function(o) { return o.fullname; }]);
    //   return sortdata
    // },
    partnerid() {
      return this.$store.getters.partner
    },
  },
  methods: {
    // 取 未讀 我的預約 數量
    getCountByUnreadSchedule() {
      getCountByUnreadSchedule().then(res => {
        if(res.data.status=='OK'){
          this.$store.commit('SET_SCHEDULE_UNFINISH_TOTAL',res.data.count)
        }
      })
      .catch((error) => {
        console.log('schedule count schedule : '+error)
      })
    },
    // 判斷時間未過期，顯示 編輯&刪除 按鈕
    checkTime(time) {
      var btnstatus = false
      var g1 = new Date()
      var g2 = new Date(time)
      if (g1.getTime() < g2.getTime())
        btnstatus = false
      else if (g1.getTime() > g2.getTime())
        btnstatus = true
      else
        btnstatus = false
      return btnstatus
    },
    addMemberDoc(data) {
      const index = this.selectpid.pids.indexOf(data.pid)
      if (index !== -1) {
        this.selectpid.pids.splice(index, 1)
        this.selectpid.pnames.splice(index, 1)
        // this.selectedPid.splice(index, 1)
      } else {
        this.selectpid.pids.push(data.pid)
        this.selectpid.pnames.push(data.name)
      }
    },
    // 我的預約 狀態
    notify(color, title, text){
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
        position:'top-center'
      })
    },
    // 取 我的預約 List
    getScheduleList(page) {
      fetchSchedule(page).then((res) => {
        var tmpdata = res.data.items
        if (tmpdata.length != 0){
          if(res.data.status=='OK'){
            // this.scheduleData = _.unionBy(this.scheduleData,tmpdata,'jobid')
            // this.scheduleData = _.sortBy(this.scheduleData, ['jobid']).reverse()
            this.scheduleData = tmpdata
            this.total = res.data.total
          }
        }
        else{
          this.nodataFlag = 1
        }
      }).then(() => {
        this.getCountByUnreadSchedule()
      })
    },
    // 開啟 編輯我的預約 視窗
    showEditDialog(item) {
      this.editSchedulePopup = true
      this.editContent = item.message
      this.editscheduleTime = item.send_at
      this.editid = item.id
    },
    // 開啟我的預約視窗
    showAddMessage(){
      this.DoctorListByPartner()
      this.getMemberFilter()
      this.addMessage = true
    },
    // 傳送我的預約
    sendMsgSchedule() {
      let _self = this
      var payload = {
        'message': _self.msgaddtime,
        'schedule': _self.selectedDateTime.getTime()/1000,
        'identify_radio_type': _self.identify_radio_type,
        'partnerid':localStorage.getItem('partnerid')
      }
      // 0:傳送通知給民眾
      if(_self.identify_radio_type=="0"){
        payload.to_pid = _self.selectpid.pids
      }
      // 1:傳送通知給醫生
      else if(_self.identify_radio_type=="1"){
        payload.to_did = _self.selectedDid
      }
      // 2:傳送通知給單位內所有的民眾
      else if(_self.identify_radio_type=="2"){
        payload.to_unit = _self.selectedUnit
      }
      saveSchedule(payload).then(res => {
        if(res.data.status == 'OK'){
          _self.notify('gray', _self.$t('message.send_success'), '')
          _self.getCountByUnreadSchedule()
          _self.getScheduleList(1)
          this.close()
        }
      })
    },
    close(){
      let _self = this
      _self.message = ''
      _self.selectedDid = ''
      _self.selectedDateTime=''
      _self.query = ''
      _self.selectpid.pids= []
      _self.selectpid.pnames= []
      _self.addMessage = false
      _self.$store.commit('SET_ALL_VIPMEMBERS',[])
    },
    // 編輯 我的預約
    async updateSchedule() {
      if(this.editContent==''){
        alert('content not empty')
        return false
      }
      var postdata = {
        id: this.editid,
        send_time: this.editscheduleTime,
        content: this.editContent,
        partnerid:localStorage.getItem('partnerid')
      }
      updateSchedule(postdata).then((res) => {
        if(res.data.status=='OK'){
          this.notify('gray', this.$t('message.update_success'), '')
          this.editSchedulePopup = false
        }else{
          this.notify('danger', this.$t('message.update_error'), '')
        }
      }).then(() => {
        this.scheduleData = []
        this.nodataFlag = 0
      }).then(() => {
        this.getCountByUnreadSchedule()
        this.getScheduleList(1)
      })
    },
    // 刪除 我的預約
    delSchedule(item) {
      var payload = {
        id: item.id
      }
      delSchedule(payload).then(res => {
        if(res.data.status=='OK'){
          this.notify('gray', this.$t('message.delete_success'), '')
        }
      }).then(() => {
        this.scheduleData = []
        this.reload();
      })
    },
    // 滾動時觸發
    scrolling(){
      this.scroll = document.documentElement.scrollTop
    },
    // 取會員list
    getVIPMember(){
      if(this.query == '') {
        this.$store.commit('SET_ALL_VIPMEMBERS',[])
        return
      }
      var payload = {
        'partnerid': this.partnerid,
        'limit': 50,
        'query': this.query
      }
      this.$store.dispatch('getVIPMember', payload)
    },
    DoctorListByPartner(){
      var _self= this
      var payload = {
        did:this.did,
        partnerid:localStorage.getItem('partnerid'),
        query: ''
      }
      QueryDoctorListByPartner(payload).then(res => {
        if(res.data.status=='OK'){
          _self.contacts = res.data.data
        }
      })
    },
    // 取公司和群組清單
    getMemberFilter() {
      var payload = {
        "partner_id": this.partnerid
      }
      getMemberFilter(payload).then((res) => {
        if(res.data.status === 'OK'){
          this.unitList    = res.data.data.enterprise_list
        }
      })
    },
  },
  mounted() {
    this.getScheduleList(1)
    window.addEventListener('scroll', this.scrolling)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrolling)
  },
}
</script>

<style lang="scss">
.el-radio__input.is-checked+.el-radio__label {
  color: #003f8e !important;    
  border-color: #003f8e !important;
}
.el-radio__input.is-checked .el-radio__inner{
  background-color: #003f8e !important;
}
.dialog-doc-section{
  background-color: #eee;
  // margin-top: 0.5rem;
  padding: 0.5rem;
}
.dialog-doc-section .filter{
  width: 200px;
  margin-bottom: 0.5em;
}
.dialog-doc-section .list{
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
}
.dialog-doc-section .list .item{
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.4rem;
  cursor: pointer;
  border: 1px solid #ddd;
}
.dialog-doc-section .list .item:hover{
  background-color: #eee;
}
</style>
